//Core
import React from "react"

//Components
import Accordion from "./Accordion"

//Styles
import style from "./style.module.scss"

const FAQ = () => {
  return (
    <section className={style.faq}>
      <h3 className={style.title}>Запитання та відповіді</h3>
      <Accordion />
    </section>
  )
}

export default FAQ
